import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { ElementSpeedIcon05x } from '@doltech/icons/ElementSpeedIcon05x';
import { ElementSpeedIcon075x } from '@doltech/icons/ElementSpeedIcon075x';
import { ElementSpeedIcon125x } from '@doltech/icons/ElementSpeedIcon125x';
import { ElementSpeedIcon15x } from '@doltech/icons/ElementSpeedIcon15x';
import { ElementSpeedIcon1x } from '@doltech/icons/ElementSpeedIcon1x';
import { innerBorder } from '@doltech/utils/lib/css-style';
import { colorsV2 } from '../../colors-v2';

const Main = styled.div``;

const SpeedItemSelected = styled.div`
  padding: 8px;
  border-radius: 40px;
  ${innerBorder(`2px solid ${colorsV2.gray20}`)};
  cursor: pointer;

  svg {
    color: #000;
  }

  &:hover {
    background-color: ${colorsV2.gray20};
  }
`;

interface ButtonVideoPlayerControlSpeedLightProps {
  onSelect: (value: number) => void;
  className?: string;
  options: number[];
  defaultValue: number;
}

const speedOptions = [
  {
    value: 0.5,
    icon: <ElementSpeedIcon05x />,
  },
  {
    value: 0.75,
    icon: <ElementSpeedIcon075x />,
  },
  {
    value: 1,
    icon: <ElementSpeedIcon1x />,
    defaultValue: true,
  },
  {
    value: 1.25,
    icon: <ElementSpeedIcon125x />,
  },
  {
    value: 1.5,
    icon: <ElementSpeedIcon15x />,
  },
];

const getSpeedIconFromValue = (speedValue) =>
  speedOptions.find((item) => item.value === speedValue)?.icon;

export const ButtonVideoPlayerControlSpeedLight = (
  props: ButtonVideoPlayerControlSpeedLightProps
) => {
  const { className, options, defaultValue, onSelect } = props;
  const [value, setValue] = React.useState(defaultValue || 1);

  const selectNextValue = () => {
    const index = options.findIndex((speed) => speed === value);
    const nextIndexSelected = (index + 1) % options.length;
    setValue(options[nextIndexSelected]);
    onSelect(options[nextIndexSelected]);
  };

  return (
    <Main
      className={cl('button-video-player-control-speed-light', className)}
      onClick={selectNextValue}
    >
      <SpeedItemSelected>{getSpeedIconFromValue(value)}</SpeedItemSelected>
    </Main>
  );
};
